export enum TipoChamado {
  Cotacao = 1,
  Endosso = 2,
  Todos = 3
}
